/* eslint-disable react/no-array-index-key */
import React from "react";
import Card from "../common/Card/Card";
import Skeleton from "../common/Skeleton/Skeleton";

interface Props {
    className?: string;
    rows?: number;
    columns?: number;
}

const SkeletonTable = ({ className, rows = 5, columns = 4 }: Props) => (
    <Card padding="large" className={className}>
        <div className="flex flex-col gap-2 overflow-hidden">
            <div className="space-y-1 mb-1">
                <Skeleton width="6rem" />
            </div>
            <div
                className="grid gap-1 grid-cols"
                style={{
                    gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
                }}
            >
                {[...Array(columns)].map((_, i) => (
                    <div key={i}>
                        <Skeleton width="4rem" height="0.75rem" />
                    </div>
                ))}
            </div>
            <div>
                {[...Array(rows)].map((_, i) => (
                    <div
                        key={i}
                        className="grid gap-1 border-b border-b-pine-900 last:border-b-0 py-1"
                        style={{
                            gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
                        }}
                    >
                        {[...Array(columns)].map((_, i) => (
                            <div key={i} className="space-y-0.5">
                                <Skeleton width="3rem" height="0.5rem" />
                                <Skeleton width="9rem" height="0.5rem" />
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    </Card>
);

export default SkeletonTable;
